import { render } from "./LoansView.vue?vue&type=template&id=1d58a822"
import script from "./LoansView.vue?vue&type=script&lang=js"
export * from "./LoansView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__